import React from "react";
import Functions from "../../src/functions";
const ThemeFunctions = {};

export default ThemeFunctions;
